import React, { useContext } from 'react';
import AboutCRISCCourse from './AboutCRISCCourse';
import CRISCCourseFee from './CRISCCourseFee';
import AboutCRISCTrainer from './AboutCRISCTrainer';
import { AiOutlineArrowRight } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';
import './CRISCCourseDetails.css';
import { AllContext } from '../../../../contextData/AllContext';

const CRISCCourseDescription = () => {
    const { courseName, setCourseName, } = useContext(AllContext);
    setCourseName("CRISC Certification");
    const navigate = useNavigate();

    return (
        <div>
            <div className='  container'>
                <div className=' col-lg-8 mx-auto mb-2'>
                    <AboutCRISCCourse></AboutCRISCCourse>
                    <CRISCCourseFee></CRISCCourseFee>
                    <AboutCRISCTrainer></AboutCRISCTrainer>
                </div>

                <div className='flex justify-center items-center text-center mb-4'>
                    <button
                        onClick={() => navigate("/registration/:id")}
                        className="sliderBtnBottom flex items-center gap-1"
                    >
                        <span className=""> Registration</span>
                        <AiOutlineArrowRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CRISCCourseDescription;